import DoublePage from '../Components/DoublePage.js';
import '../styles/DoublePage.scss';
import '../styles/Agence.scss';
import { ReactComponent as Crea } from '../svg/crea.svg';
import { ReactComponent as Exe } from '../svg/exe.svg';
import { ReactComponent as Real } from '../svg/real.svg';

const Pole = ({ title, children }) =>
    <section>
        <h2>{title}</h2>
        <div className="pole-description">
            {children}
        </div>
    </section>

const Agence = () =>
    <DoublePage
        id="agence"
        minor={
            <div>
                <h1>Les Publinautes</h1>
                <h2>identité - communication - édition - multimédia</h2>

                <p>Une équipe dynamique aux compétences complémentaires travaillant de manière transversale pour animer et coordonner toutes les étapes d'un projet, de sa conception à sa réalisation.</p>
            </div>
        }
        major={
            <div>
                <h2>Répartie en 3 pôles</h2>

                <Pole title={<Crea/>}>
                    <ul>
                        <li>Positionnement et évolution de marques</li>
                        <li>Développement de systèmes d’identité visuelle</li>
                        <li>Création de lignes graphiques éditoriales</li>
                        <li>Multimédia, sites Internet</li>
                        <li>Traitement signalétique et aménagement de réseaux d’enseignes</li>
                        <li>Élaboration de concepts de communication globale</li>
                    </ul>
                </Pole>

                <Pole title={<Exe/>}>
                    <ul><li>Guides de normes</li>
                        <li>Notices techniques</li>
                        <li>Brochures, catalogues</li>
                        <li>Dossiers de presse</li>
                        <li>Papeterie</li>
                        <li>Flyers, invitations, mailings</li>
                        <li>PLV, panneaux & décors</li>
                    </ul>
                </Pole>

                <Pole title={<Real/>}>
                    <p>Une véritable plate-forme technique d’imprimerie qui conçoit et optimise le traitement de votre projet sur le matériel le plus adapté.</p>
                </Pole>
            </div>
        }
    />

export default Agence;